const $filters = $('.js-filters');

if ($filters.length) {
  const currentCollection = $filters.data('collection');
  const $win = $(window);
  const $doc = $(document);
  const TABLET_WIDTH = 1023;

  let lastPartOfHref = '';
  let selectedValuesArray = '';
  let windowPath = '';
  let windowSearch = '';
  let newHref = '';
  let newoptionHref = '';

  const currentStates = () => {
    windowPath = window.location.pathname;
    windowSearch = window.location.search;

    lastPartOfHref = windowPath.split('/').length > 3 ? windowPath.split('/')[windowPath.split('/').length - 1] : '';
    selectedValuesArray = lastPartOfHref.split('+');

    // Show clear links
    if (selectedValuesArray.length > 0 && selectedValuesArray[0] != '') {
      $('.js-clear-all').removeClass('hidden');

      selectedValuesArray.map(tag => {
        // Set current class of selected options
        const $selectedFilterOption = $filters
          .find(`a[href^="${tag}"]`)
          .parent()
          .addClass('current')
          .addClass('is-checked')
          .closest('.filter__option')

        $selectedFilterOption
          .addClass('filter__option--selected')
          .addClass('is-expanded')

        const counterTags = $selectedFilterOption.find('.current').length

        $selectedFilterOption
          .find('.filter__number')
          .text(counterTags)
      });
    }
  };

  currentStates();

  $doc.on('click', '.js-filter-text', function(event) {
    event.preventDefault();
    const $this = $(this);

    $this
      .next('ul')
      .stop()
      .slideToggle()
      .parent()
      .toggleClass('is-expanded')
      .siblings()
      .removeClass('is-expanded')
      .find('ul')
      .slideUp();
  });

  $doc.on('click', '.js-filters .js-filter-option', function(event) {
    event.preventDefault();

    const $this = $(this);
    const optionHref = $this.attr('href');

    if ($this.parent().hasClass('current')) {
      newHref = lastPartOfHref.split('+');
      newHref = newHref.filter(tag => tag !== optionHref).join('+');
    }

    if (!$this.parent().hasClass('current')) {
      const type = optionHref.split('-')[0];

      if (lastPartOfHref.indexOf(type) !== -1) {
        newHref = lastPartOfHref.split('+').filter(tag => !tag.indexOf(type) === -1);
        newHref.push(optionHref);
        newHref = newHref.join('+');
      } else {
        newHref = lastPartOfHref !== '' ? `${lastPartOfHref}+${optionHref}` : `${optionHref}`;
      }
    }

    window.location = currentCollection + '/' + newHref;
  });

  $doc.on('click', '.js-filters .js-filter-option-sibling', function(event) {
    event.preventDefault();
    const $this = $(this)

    $this
      .parent()
      .toggleClass('is-checked')
      .siblings()
      .removeClass('is-checked')
      .removeClass('current')

    $this
      .closest('.filter__option')
      .siblings()
      .find('.is-checked')
      .removeClass('is-checked')

    $this
      .closest('.filter__option')
      .siblings()
      .find('.current')
      .removeClass('current')
  });

  $doc.on('click', '.js-filters .js-filters-btn', function(e) {
    e.preventDefault()
    const $filters = $(this).closest('.js-filters')
    const $filterChecked = $filters.find('.is-checked')

    if ($filterChecked.length) {
      $filterChecked.removeClass('current').find('.js-filter-option').trigger('click')
    } else {
      window.location = currentCollection + '/' + newHref;
    }
  })

  $doc.on('click', '.js-clear-option', function(e) {
    e.preventDefault()
    const $option = $(this).closest('.filter__option')
    const selectedOption = $option.find('.current a').attr('href')
    const hrefOption = window.location.href.replace(selectedOption, '').replace('+?', '?')

    window.location = hrefOption
  })
}
